import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ConsentComponent from "./Consent";
import { Form as JSONForm } from "@rjsf/mui"; // Assuming you have this installed
import validator from "@rjsf/validator-ajv8";
import FileFactory from "../../components/filefactory/fileWidget/FileFactory";

const RjfsForm = ({ jsonSchemaForm }) => {
  const [showConsent, setShowConsent] = useState(true);
  const [consentInfo, setConsentInfo] = useState(null);
  const formRef = useRef({});
  const requiredFieldsRef = useRef([]);
  function areAllRequiredFieldsFilled(requiredFields, fileAttributes) {
    for (const field of requiredFields) {
      if (!fileAttributes[field] || fileAttributes[field].length === 0) {
        return !focusElementWithRedBorder(`${field}`);
      }
    }
    return true;
  }
  const handleConsent = () => {
    setShowConsent(!showConsent);
  };
  function focusElementWithRedBorder(id) {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      element.style.border = "2px solid red";
      element.style.borderRadius = "10px";
      element.style.padding = "10px";
      return true;
    }
    return false;
  }

  useEffect(() => {
    setShowConsent(true);
    console.log(jsonSchemaForm);
    if (jsonSchemaForm) {
      setConsentInfo(jsonSchemaForm["consent"]);
    }
  }, [jsonSchemaForm]);
  const handleSubmit = async ({ formData, errors }, e) => {
    // console.log(errors);
    // console.log(formData);
    // setFormData(formData);
    if (
      !areAllRequiredFieldsFilled(requiredFieldsRef.current, formRef.current)
    ) {
      return;
    }

    console.log(formData);

    // switch (dataset.upload_type) {
    //   case "django":
    //     handleDirectAPI(formData);
    //     break;
    //   case "tus":
    //     handleTusdAPI(formData);
    //     break;
    //   default:
    //     handleDirectAPI(formData);
    //     console.log("Dataset Upload Type Missing.");
    // }
  };
  const customWidgets = {
    FileWidget: (props) => (
      <FileFactory
        requiredFieldsRef={requiredFieldsRef}
        formRef={formRef}
        {...props}
      />
    ),
  };
  return (
    <Box p={4}>
      {showConsent ? (
        <div>
          <ConsentComponent
            handleConsent={handleConsent}
            consentInfo={consentInfo}
          />
        </div>
      ) : (
        <>
          <Typography variant="h5">Generated Form</Typography>
          <JSONForm
            schema={jsonSchemaForm}
            validator={validator}
            uiSchema={jsonSchemaForm?.ui_schema}
            widgets={customWidgets}
            onSubmit={handleSubmit}
          />
        </>
      )}
    </Box>
  );
};

export default RjfsForm;
